require('../lib/bootstrap');

// App dependency imports.
import { createInertiaApp } from '@inertiajs/vue3';
import { createApp, h } from "vue";

// Package imports.
import Swal from "sweetalert2";
import AOS from 'aos';

// Style imports.
import 'aos/dist/aos.css';

createInertiaApp({
    resolve: async (name) => {
        return await import(`./Pages/${name}`);
    },
    progress: {
        delay: 500,
        color: '#ba0c2f'
    },
    setup ({el, App, props, plugin}) {
        createApp({render: () => h(App, props)})
            .use(plugin)
            .mixin({
                methods: {
                    /**
                     * Group an object by the given key.
                     *
                     * @param list
                     * @param key
                     * @returns {*}
                     */
                    groupBy (list, key) {
                        key = key.split('.');

                        return Object.values(list).reduce(function(carry, item) {
                            let index = item;

                            for (let i of key) {
                                index = index[i];
                            }

                            (carry[index] = carry[index] || []).push(item);

                            return carry;
                        }, {});
                    },
                    /**
                     *
                     * Get the key value pairs of a form.
                     *
                     * @param formElement
                     * @returns {{[p: string]: File | string}}
                     */
                    getFormData(formElement) {
                        return Object.fromEntries(
                            new FormData(formElement).entries()
                        )
                    },
                    success(title, message) {
                        this.toast.fire({
                            icon: 'success',
                            title: title,
                            text: message
                        });
                    },
                    message(title, message) {
                        this.toast.fire({
                            icon: 'info',
                            title: title,
                            text: message
                        });
                    },
                    error(title, message) {
                        this.toast.fire({
                            icon: 'error',
                            title: title,
                            text: message
                        });
                    },
                    route
                },
                data() {
                    return {
                        toast: Swal.mixin({
                            toast: true,
                            position: 'top-right',
                            showConfirmButton: false,
                            showCloseButton: true,
                            timer: 4500,
                            timerProgressBar: true
                        })
                    }
                }
            })
            .mount(el)
    },
}).then(_ => {
    AOS.init();
    /**
     * Password toggler.
     */
    $('body').on('click', '.password-label .toggler', function() {
        let inputSelector = $(this).siblings('input');

        if (inputSelector.attr('type') === 'password') {
            inputSelector.attr('type', 'text');
        } else {
            inputSelector.attr('type', 'password');
        }
    });
});
